import PropTypes from 'prop-types';

export const AgentFactorySuccessProps = {
  locales: PropTypes.object,
  ssoUrl: PropTypes.string,
  DomainsList: PropTypes.array,
};
